import { Delta } from 'quill'

import { Action } from 'modules/store'

export type StripHtmlPayload = {
  html: string | Delta | undefined
  complete(newValue: string): void
}

export const STRIP_HTML_FORM = '[shared] Strip Html Form'

export class StripHtmlFormAction implements Action {
  readonly type = STRIP_HTML_FORM
  constructor(public payload: StripHtmlPayload) {}
}

type FormActions = StripHtmlFormAction

export default FormActions



// WEBPACK FOOTER //
// ./src/app/shared/store/form.actions.ts